import { Task } from '../types';

type TaskCreationData = {
    title: string;
    description?: string;
    priority: 'low' | 'medium' | 'high';
    tag?: string;
    type: 'custom' | 'log_analysis' | 'security' | 'monitoring';
    status: 'open' | 'in_progress' | 'resolved' | 'closed';
    context?: any;
    contextDescription?: string;
    affectedFiles?: string;
};

export const createTaskPayload = (data: TaskCreationData): Partial<Task> => {
    const { type, context, contextDescription, affectedFiles } = data;

    const buildContext = () => {
        switch (type) {
            case 'custom':
                // This logic handles the more complex context for custom tasks.
                const customContext = {
                    ...context,
                    type: 'custom',
                    contextDescription: contextDescription ?? context?.contextDescription ?? data.description,
                    affectedFiles: affectedFiles ?? context?.affectedFiles,
                };
                // Clean up undefined fields from the context
                Object.keys(customContext).forEach(key => {
                    if (customContext[key as keyof typeof customContext] === undefined) {
                        delete customContext[key as keyof typeof customContext];
                    }
                });
                return customContext;
            default:
                // A sensible default for any other types
                return {
                    type: type,
                    ...context,
                };
        }
    };

    // Create a copy of data to avoid modifying the original object
    const payloadData = { ...data };

    // Remove the context-specific fields from the top-level of the payload
    // as they are now handled within the context object.
    delete payloadData.contextDescription;
    delete payloadData.affectedFiles;

    return {
        ...payloadData,
        context: buildContext(),
    };
};
